import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ml-4 text-caption"
}
const _hoisted_2 = {
  key: 0,
  class: "mt-2"
}

import { ref, computed, onMounted } from 'vue';

import datePresets from '@/components/filters/date/Presets.vue';
import customDateRange from '@/components/filters/date/CustomRange.vue';
import { useDisplay } from 'vuetify';

const TZ = 'America/Monterrey';

export default /*@__PURE__*/_defineComponent({
  __name: 'Container',
  emits: ["rangeUpdated"],
  setup(__props, { emit: __emit }) {

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const emit = __emit;

// Helpers
const toISO = (d: Date) => d.toLocaleString('sv-SE', { timeZone: TZ }).slice(0, 10);

// State
const menuDesktop = ref(false);
const mainMenu = ref(false);
const showInlinePicker = ref(false);
const pickerRange = ref<Date[] | null>(null);

const minDate = ref('2020-01-01');
const maxDate = ref(toISO(new Date()));

// Presets (devuelven Date[] | null)
const presets = [
  { label: 'Hoy', range: () => { const t = new Date(); return [t, t] as Date[]; } },
  { label: 'Ayer', range: () => { const d = new Date(); d.setDate(d.getDate() - 1); return [d, d] as Date[]; } },
  { label: 'Últimos 7 días', range: () => { const today = new Date(); const weekAgo = new Date(); weekAgo.setDate(today.getDate() - 6); return [weekAgo, today] as Date[]; } },
  { label: 'Este mes', range: () => { const t = new Date(); const first = new Date(t.getFullYear(), t.getMonth(), 1); const last = new Date(t.getFullYear(), t.getMonth() + 1, 0); return [first, last] as Date[]; } },
  { label: 'Mes pasado', range: () => { const t = new Date(); const first = new Date(t.getFullYear(), t.getMonth() - 1, 1); const last = new Date(t.getFullYear(), t.getMonth(), 0); return [first, last] as Date[]; } },
  { label: 'Todos los tiempos', range: () => null },
] as const;

const activePreset = ref<string>(presets[2].label); // 'Últimos 7 días'

// UI text
const displayRange = computed(() => {
  if (activePreset.value === 'Todos los tiempos') return 'Todos los tiempos';
  if (!pickerRange.value || pickerRange.value.length === 0) return '';
  const sorted = [...pickerRange.value].sort((a, b) => a.getTime() - b.getTime());
  const start = toISO(sorted[0]);
  const end = toISO(sorted[sorted.length - 1]);
  return start === end ? start : `${start} - ${end}`;
});

// Orquestación
function emitRange(range: Date[] | null) {
  if (!range) { emit('rangeUpdated', null); return; }
  const sorted = [...range].sort((a, b) => a.getTime() - b.getTime());
  const start = new Date(sorted[0]);
  const end = new Date(sorted[sorted.length - 1]);
  emit('rangeUpdated', { start, end });
}

function selectPreset(preset: { label: string; range: () => Date[] | null }) {
  const range = preset.range();
  pickerRange.value = range;
  activePreset.value = preset.label;
  emitRange(range);
}

function applyCustomRange() {
  if (!pickerRange.value || pickerRange.value.length === 0) {
    activePreset.value = 'Todos los tiempos';
    emitRange(null);
    return;
  }
  const sorted = [...pickerRange.value].sort((a, b) => a.getTime() - b.getTime());
  const start = sorted[0];
  const end = sorted[sorted.length - 1];
  activePreset.value = ''; // limpias el preset al usar custom
  emitRange([start, end]);
}

onMounted(() => {
  selectPreset(presets[2]); // 'Últimos 7 días'
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(["mb-4", !isMobile.value?'pa-3':'']),
    flat: ""
  }, {
    default: _withCtx(() => [
      (!isMobile.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            align: "center",
            dense: ""
          }, {
            default: _withCtx(() => [
              (displayRange.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createVNode(_component_v_icon, {
                      size: "14",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("mdi-calendar")
                      ])),
                      _: 1,
                      __: [10]
                    }),
                    _createTextVNode(" " + _toDisplayString(displayRange.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              _createVNode(datePresets, {
                presets: presets,
                activePreset: activePreset.value,
                onSelectPreset: selectPreset
              }, null, 8, ["activePreset"]),
              _createVNode(_component_v_menu, {
                modelValue: menuDesktop.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((menuDesktop).value = $event)),
                "close-on-content-click": false,
                transition: "scale-transition",
                "offset-y": ""
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({
                    class: "ml-2",
                    color: "primary"
                  }, props, {
                    variant: "text",
                    size: "small"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "18",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode("mdi-calendar-range")
                        ])),
                        _: 1,
                        __: [11]
                      }),
                      _cache[12] || (_cache[12] = _createTextVNode(" Rango personalizado "))
                    ]),
                    _: 2,
                    __: [12]
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(customDateRange, {
                    modelValue: pickerRange.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pickerRange).value = $event)),
                    minDate: minDate.value,
                    maxDate: maxDate.value,
                    onApplyCustomRange: _cache[1] || (_cache[1] = () => { applyCustomRange(); menuDesktop.value = false; }),
                    onCancel: _cache[2] || (_cache[2] = ($event: any) => (menuDesktop.value = false))
                  }, null, 8, ["modelValue", "minDate", "maxDate"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            align: "center",
            dense: "",
            class: "ma-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_menu, {
                modelValue: mainMenu.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((mainMenu).value = $event)),
                "close-on-content-click": false,
                transition: "scale-transition",
                location: "bottom start",
                offset: 8
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({ block: "" }, props, {
                    variant: "tonal",
                    size: "small",
                    class: "py-5",
                    "aria-label": "Abrir filtros de fecha"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        size: "18",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode("mdi-calendar-range")
                        ])),
                        _: 1,
                        __: [13]
                      }),
                      _createTextVNode(" " + _toDisplayString(displayRange.value || 'Selecciona un rango'), 1)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "pa-2 text-center",
                    "min-width": "320",
                    "max-width": "92vw"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(datePresets, {
                        presets: presets,
                        activePreset: activePreset.value,
                        onSelectPreset: _cache[4] || (_cache[4] = p => { selectPreset(p); if (p.label === 'Todos los tiempos') mainMenu.value = false; })
                      }, null, 8, ["activePreset"]),
                      _createVNode(_component_v_divider, { class: "my-2" }),
                      _createVNode(_component_v_btn, {
                        variant: "text",
                        size: "small",
                        class: "ml-2",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (showInlinePicker.value = !showInlinePicker.value))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode("mdi-calendar-range")
                            ])),
                            _: 1,
                            __: [14]
                          }),
                          _cache[15] || (_cache[15] = _createTextVNode(" Rango personalizado "))
                        ]),
                        _: 1,
                        __: [15]
                      }),
                      _createVNode(_component_v_expand_transition, null, {
                        default: _withCtx(() => [
                          (showInlinePicker.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(customDateRange, {
                                  modelValue: pickerRange.value,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((pickerRange).value = $event)),
                                  minDate: minDate.value,
                                  maxDate: maxDate.value,
                                  onApplyCustomRange: _cache[7] || (_cache[7] = () => { applyCustomRange(); showInlinePicker.value = false; mainMenu.value = false; }),
                                  onCancel: _cache[8] || (_cache[8] = ($event: any) => (showInlinePicker.value = false))
                                }, null, 8, ["modelValue", "minDate", "maxDate"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})